/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
import React, { useContext } from 'react';
import SlideThreeCard from './SlideThreeCard';
import './Carousel.css';
import CurrentUserContext from '../../Contexts/userContexts'

const SlideThree = () => {
    let teamInfo=[]
    const {  singlePlayer, slideTeam} = useContext(CurrentUserContext)
    

    slideTeam.map(teamSelect =>{ singlePlayer.map(playerteam=>{
        if (teamSelect.strTeam===playerteam.player[0].strTeam && teamInfo.includes(teamSelect.strTeam)==!'false'){teamInfo.push(teamSelect)}})})
       
        let max = teamInfo.length-1;
        let min =0;
        let value = Math.floor(Math.random()*(max - min + 1) + min);
        
 

    const displayTeamsInfo = <SlideThreeCard {...teamInfo[value]} />


    return (
        <div className="modal-content">
            {displayTeamsInfo}
        </div>

    )
}

export default SlideThree